import React, { Component, Fragment } from 'react';
import axios from 'axios';
import HoursItem from './HoursItem';

class Hours extends Component {
	constructor(props) {
		super(props);

		this.state = {
			error: null,
			isLoaded: false,
			hours: [],
		};
	}

	componentDidMount() {
		const cockpit_base = `${process.env.REACT_APP_COCKPIT_URL}/cockpit/api/collections/get/`;
		const cockpit_token = process.env.REACT_APP_COCKPIT_TOKEN;

		axios.get(`${cockpit_base}hours?token=${cockpit_token}`)
			.then((res) => {
				const hours = res.data;
				this.setState({ hours });
				// console.log(this.state);
			})
			.catch((error) => {
				// console.log(error);
				this.setState({ error });
				// console.log(this.state);
			});
	}

	render() {
		return (this.state.hours.entries.length > 0) ? (
			<Fragment>
				{this.state.hours.entries && (
					<section className="hours">
						<h2>Hours</h2>
						<div className="hours-block-wrapper">
							{Object.keys(this.state.hours.entries).map(key => (
								<HoursItem
									key={key}
									index={key}
									days={this.state.hours.entries[key].days}
									time={this.state.hours.entries[key].time_span}
								/>
							))}
						</div>
					</section>
				)}
			</Fragment>
		) : (
			<Fragment />
		);
	}
}

export default Hours;
